import { columnKeyMap } from './columnKeyMap';

const {
  tenantMark,
  alive,
  houseStageName,
  addressStageName,
  flatAcceptanceResult,
  flat,
  address,
  isVerified,
  houseType,
  region,
} = columnKeyMap;

export const filterableColumnsData = {
  [tenantMark]: { name: 'isOwner' },
  [alive]: { name: 'alive' },
  [houseStageName]: { name: houseStageName },
  [addressStageName]: { name: addressStageName },
  [flatAcceptanceResult]: { name: flatAcceptanceResult },
  [flat]: { name: 'address.typeName' },
  [address]: { name: 'houseId' },
  [isVerified]: { name: isVerified },
  [houseType]: { name: 'type.name' },
  [region]: { name: 'regionName' },
};
